import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

const sharerWidth = 360;

export const useStyles = makeStyles((theme) => ({
  sharerContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
  },
  sharerShareOptions: {
    position: "absolute",
    top: -120,
    left: -sharerWidth / 2,
    width: sharerWidth,
    padding: theme.spacing(2),
    display: "none",
  },
  sharerButton: {
    width: 40,
  },
}));
